import { BaseHTMLElement, customElement, onEvent } from 'dom-native';

import type { ConnectionStatus } from '@/types/chat';
import { icon } from '@/utils/icons';

interface SessionInfoState {
  open: boolean;
  sessionId: string;
  status: ConnectionStatus;
}

function escapeHtml(value: string): string {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;');
}

@customElement('help-agent-session-info')
export class HelpAgentSessionInfo extends BaseHTMLElement {
  private _state: SessionInfoState = {
    open: false,
    sessionId: '',
    status: 'disconnected',
  };

  init(): void {
    super.init();
    this.render();
  }

  setState(nextState: SessionInfoState): void {
    this._state = nextState;
    if (this.initialized) {
      this.render();
    }
  }

  private render(): void {
    const statusText: Record<ConnectionStatus, string> = {
      connected: 'Connected',
      disconnected: 'Disconnected',
      connecting: 'Connecting...',
    };

    this.hidden = !this._state.open;
    this.innerHTML = `
      <div class="help-agent-session-panel">
        <div class="help-agent-session-row">
          <div class="help-agent-session-copy">
            <span class="help-agent-session-label">Session ID</span>
            <button type="button" class="help-agent-session-copy-btn" data-action="copy-session" aria-label="Copy session ID">
              ${icon('copy-document', { size: 14 })}
            </button>
          </div>
          <code class="help-agent-session-value">${escapeHtml(this._state.sessionId || 'Unavailable')}</code>
        </div>
        <div class="help-agent-status-row" role="status" aria-live="polite">
          <span class="help-agent-status-dot is-${this._state.status}"></span>
          <span class="help-agent-status-text">${statusText[this._state.status]}</span>
        </div>
      </div>
    `;
  }

  @onEvent('click', '[data-action="copy-session"]')
  onCopySession(): void {
    this.dispatchEvent(new CustomEvent('help-agent:copy-session', { bubbles: true, composed: true }));
  }
}
